module.exports = __webpack_public_path__ + "img/int7.f8596a6b.jpg";